const EMPTY_HTML_VALUES = new Set([
  '',
  '<p></p>',
  '<p><br></p>',
  '<p><br data-cke-filler="true"></p>',
  '<p>&nbsp;</p>',
  '<div></div>',
  '<div><br></div>',
  '<div>&nbsp;</div>'
]);

export const isEditorEmpty = (html: string | null | undefined): boolean => {
  if (html == null) return true;

  return EMPTY_HTML_VALUES.has(html.trim());
};

export const normalizeEditorValue = (html: string | null | undefined): string | null =>
  isEditorEmpty(html) ? null : (html ?? null);

export const isEditorValueEqual = (
  left: string | null | undefined,
  right: string | null | undefined
): boolean => normalizeEditorValue(left) === normalizeEditorValue(right);
